import Cookies from 'js-cookie'

export function cookie() {
    const closeCookie = $('.cookie-message__btn');
    const cookieMessageItem = $('.cookie-message');

    Cookies.set('name', 'value', {
        expires: 30
    })

    function cookieMessage() {
        const cookieValue = Cookies.get('name');

        if(cookieValue != 'value') {
            cookieMessageItem.addClass('active');
        }
    }

    closeCookie.on('click', function(){
        cookieMessageItem.removeClass('active')
    })

    window.addEventListener("load", function () {
        setTimeout(cookieMessage, 3000);
    });
}


// WEBPACK FOOTER //
// app/scripts/components/cookie.js